<template>
  <main class="home-page" :style="pageStyle">
    <div class="page-shade"></div>
    <HomeHeader :config="home.config" />

    <div class="home-content">
      <HeroIntro :config="home.config" :social-links="home.socialLinks" />
      <div class="right-panel">
        <InfoCards
          :quote="home.quote"
          :weather="home.weather"
          :weather-status="weatherStatus"
        />
        <SiteGrid :site-links="home.siteLinks" />
      </div>
    </div>

    <footer class="home-footer">
      {{ home.config.copyrightText }}
      <span v-if="home.config.icpText"> {{ home.config.icpText }}</span>
      <span class="footer-heart">♥</span>
    </footer>
    <MusicPlayer :music="home.music" />
  </main>
</template>

<script>
import axios from 'axios';
import { getHome, getCurrentWeather, defaultHome } from '../api/home';
const { getBrowserCoordinates, reverseGeocode } = require('../utils/weather-location');
import HomeHeader from '../components/home/HomeHeader.vue';
import HeroIntro from '../components/home/HeroIntro.vue';
import InfoCards from '../components/home/InfoCards.vue';
import SiteGrid from '../components/home/SiteGrid.vue';
import MusicPlayer from '../components/home/MusicPlayer.vue';

export default {
  name: 'Home',
  components: {
    HomeHeader,
    HeroIntro,
    InfoCards,
    SiteGrid,
    MusicPlayer
  },
  data() {
    return {
      home: defaultHome,
      weatherStatus: 'configured'
    };
  },
  computed: {
    pageStyle() {
      const url = this.home.config && this.home.config.backgroundUrl
        ? this.home.config.backgroundUrl
        : '/images/home-bg.png';
      return {
        backgroundImage: `url("${url}")`
      };
    }
  },
  created() {
    this.initializeHome();
  },
  methods: {
    async initializeHome() {
      this.weatherStatus = 'locating';
      const liveWeatherPromise = this.loadCurrentLocationWeather()
        .then(data => ({ data }))
        .catch(error => ({ error }));

      try {
        const data = await getHome();
        this.home = this.mergeHomeData(data);
      } catch (error) {
        this.home = this.mergeHomeData(defaultHome);
      }

      const liveResult = await liveWeatherPromise;
      if (liveResult.data) {
        this.home = {
          ...this.home,
          weather: { ...this.home.weather, ...liveResult.data }
        };
        this.weatherStatus = 'live';
      } else {
        this.weatherStatus = 'fallback';
      }
    },
    mergeHomeData(data) {
      const source = data || {};
      return {
        ...defaultHome,
        ...source,
        config: { ...defaultHome.config, ...(source.config || {}) },
        quote: { ...defaultHome.quote, ...(source.quote || {}) },
        weather: { ...defaultHome.weather, ...(source.weather || {}) },
        music: {
          ...defaultHome.music,
          ...(source.music || {}),
          config: { ...defaultHome.music.config, ...((source.music && source.music.config) || {}) },
          tracks: (source.music && source.music.tracks) || []
        }
      };
    },
    async loadCurrentLocationWeather() {
      const geolocation = window.navigator && window.navigator.geolocation;
      const coordinates = await getBrowserCoordinates(geolocation);
      const [weather, cityName] = await Promise.all([
        getCurrentWeather(coordinates.latitude, coordinates.longitude),
        reverseGeocode(axios, coordinates.latitude, coordinates.longitude)
      ]);
      return { ...weather, cityName };
    }
  }
};
</script>
